import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotificationContext } from '../../components/notifications/NotificationProvider';
import { useNotificationSummary } from '../../hooks/useNotifications';
import { formatDocumentTitle } from './formatDocumentTitle';
import { resolveRouteDocumentTitle } from './resolveRouteDocumentTitle';
import { usePageTitleContext } from './PageTitleContext';

/** Syncs `document.title` from route defaults, per-page overrides, and unread notifications. */
export default function AppDocumentTitle(): null {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const { pageTitle } = usePageTitleContext();
  const { userId, enabled } = useNotificationContext();
  const { data: summary } = useNotificationSummary(userId, enabled);

  const routeTitle = React.useMemo(
    () => resolveRouteDocumentTitle(pathname, t),
    [pathname, t, i18n.language],
  );
  const segment = pageTitle ?? routeTitle;
  const unread = summary?.unreadCount ?? 0;
  const brand = t('app.title');

  React.useEffect(() => {
    document.title = formatDocumentTitle(segment, unread, brand);
  }, [segment, unread, brand]);

  return null;
}
